import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/20/solid'
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { MdAccessibility, MdArrowDropDown, MdClose, MdEmail, MdMoveDown, MdTrendingDown } from 'react-icons/md'; // Material Design email icon
import { MdVisibility } from 'react-icons/md'; // Material Design email icon
import { MdVisibilityOff } from 'react-icons/md'; // Material Design email icon
import { MdLock } from 'react-icons/md'; // Material Design email icon
import { MdPerson } from 'react-icons/md'; // Material Design email icon
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { MdCalendarMonth } from 'react-icons/md';
import { InputAdornment } from '@mui/material';


function StudentSignUp1() {
    const [language, setLanguage] = useState(() => {
        const languageNow = localStorage.getItem('language') ? localStorage.getItem('language') : 'English';
        return languageNow;
    })
    const { t, i18n } = useTranslation();
    useEffect(() => {
        switch (language) {
            case 'English':
                i18n.changeLanguage('en');
                break;
            case 'Sinhala':
                i18n.changeLanguage('si');
                break;
            case 'Tamil':
                i18n.changeLanguage('ta');
                break;
            default:
                i18n.changeLanguage('en');
                break;
        }
        localStorage.setItem('language', language);
    }, [language]);

    const navigate = useNavigate();
    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const changeLanguage = (lang) => {
        i18n.changeLanguage(lang);
    };

    const [studentSignupDetails, setstudentSignupDetails] = useState(() => {
        const newDetails = {
            name: '',
            email: '',
            password: '',
            confirmPassword: '',
            district: '',
            gender: '',
            ethnicity: '',
            dateOfBirth: null,
        };
        const oldDetails = localStorage.getItem('studentsignup1');
        return oldDetails ? JSON.parse(oldDetails) : newDetails;
    });

    const [errors, setErrors] = useState(
        {
            noEmail: false,
            invalidEmail: false,
            noPassword: false,
            passwordsNotMatch: false,
            noName: false,
            invalidName: false,
            noDistrict: false,
            noGender: false,
            noEthnicity: false,
            noDOB: false
        }
    )

    const districtArray = ["Ampara", "Anuradhapura", "Badulla", "Batticaloa", "Colombo", "Galle", "Gampaha", "Hambantota", "Jaffna", "Kalutara", "Kandy",
        "Kegalle", "Kilinochchi", "Kurunegala", "Mannar", "Matale", "Matara", "Monaragala", "Mullaitivu", "Nuwara Eliya", "Polonnaruwa", "Puttalam",
        "Ratnapura", "Trincomalee", "Vavuniya"];

    const [isVisible, setIsVisible] = useState(false);
    const [isVisibleText, setIsVisibleText] = useState(true);

    const [isVisible2, setIsVisible2] = useState(false);
    const [isVisibleText2, setIsVisibleText2] = useState(true);

    const handleVisiblityClick = () => {
        setIsVisible(!isVisible);
        if (!isVisible && studentSignupDetails.password.length > 0) {
            setIsVisibleText(true);
        } else if (isVisible && studentSignupDetails.password.length > 0) {
            setIsVisibleText(false);
        }
    }

    const handleVisiblityClick2 = () => {
        setIsVisible2(!isVisible2);
        if (!isVisible2 && studentSignupDetails.password.length > 0) {
            setIsVisibleText2(true);
        } else if (isVisible2 && studentSignupDetails.password.length > 0) {
            setIsVisibleText2(false);
        }
    }

    const [passwordStatus, setPasswordStatus] = useState({
        weak: false,
        medium: false,
        strong: false
    })

    const errorMessages =
        [
            '',
            t('t60'),
            t('t61'),
            t('t62'),
            t('t63'),
            t('t64'),
        ]

    const [errorMessageNumber, setErrorMessageNumber] = useState(0)

    const regexPatterns = [
        /^.{1,7}$/,  // weak password
        /^(?:[a-z]{8,}|[A-Z]{8,}|[0-9]{8,}|[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]{8,})$/,  // medium password
        /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[!@#*$%^&+=]).{8,}$/,  // strong password
        /(?=.*[A-Z])/,  // contains at least 1 uppercase letter
        /(?=.*[a-z])/,  // contains at least 1 lowercase letter
        /(?=.*[0-9])/,  // contains at least 1 numeric digit
        /(?=.*[!@#*$%^&+=])/,  // contains at least 1 special character
        /^.{8,}$/,  // password length greater than 8 characters
    ];

    const [disabled, setIsDisabled] = useState(false);

    useEffect(() => {
        if (!localStorage.getItem('studentsignup1')) {
            if (!localStorage.getItem('enteredEmail')) {
                navigate('/registerasstudent')
            } else {
                if (localStorage.getItem('userStatusDetails')) {
                    const userStatusDetails = JSON.parse(localStorage.getItem('userStatusDetails'));
                    const newDetails = {
                        name: "",
                        email: userStatusDetails.sEmail,
                        password: "",
                        confirmPassword: '',
                        district: userStatusDetails.district,
                        gender: '',
                        ethnicity: '',
                        dateOfBirth: null
                        // district: 'Galle'
                    }
                    setstudentSignupDetails(newDetails)
                    setIsDisabled(true)
                } else {
                    const newDetails = {
                        name: "",
                        email: localStorage.getItem('enteredEmail'),
                        password: "",
                        confirmPassword: '',
                        district: "",
                        gender: '',
                        ethnicity: '',
                        dateOfBirth: null
                    }
                    setstudentSignupDetails(newDetails)
                    setIsDisabled(false)
                }
            }
        }
    }, [])

    const handleContinue = () => {

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const nameRegex = /^[^\d]*$/;
        let newErrors = {};
        console.log(studentSignupDetails);

        newErrors.noEmail = !studentSignupDetails.email;
        newErrors.noPassword = !studentSignupDetails.password;
        newErrors.noName = !studentSignupDetails.name;
        newErrors.noDistrict = !studentSignupDetails.district;
        newErrors.noGender = !studentSignupDetails.gender;
        newErrors.noEthnicity = !studentSignupDetails.ethnicity;
        newErrors.noDOB = !studentSignupDetails.dateOfBirth;

        if (studentSignupDetails.password && (studentSignupDetails.confirmPassword) !== (studentSignupDetails.password)) {
            newErrors.passwordsNotMatch = true;
        } else {
            newErrors.passwordsNotMatch = false;
        }

        // if ((studentSignupDetails.email) && !emailRegex.test(studentSignupDetails.email)) {
        //     newErrors.invalidEmail = true;
        // } else {
        //     newErrors.invalidEmail = false;
        // }

        if ((studentSignupDetails.name) && !nameRegex.test(studentSignupDetails.name)) {
            newErrors.invalidName = true;
        } else {
            newErrors.invalidName = false;
        }

        setErrors(newErrors);

        if (Object.values(newErrors).some((error) => error)) {
            return;
        }

        localStorage.setItem('studentsignup1', JSON.stringify(studentSignupDetails))
        navigate('/studentclassdetails');
    }

    const ethnicityArray = ['Tamil', 'Sinhala'];
    const genderArray = ['Male', 'Female'];
    const [date, setDate] = useState(()=>{
        const storedDate = localStorage.getItem('studentsignup1') ? JSON.parse(localStorage.getItem('studentsignup1')).dateOfBirth : null;
        return storedDate ? dayjs(storedDate) : null;
    })
    const [showCloseIcon, setShowCloseIcon] = useState(null)

    useEffect(() => {
        if (date !== null) {
            setShowCloseIcon(true)
        } else {
            setShowCloseIcon(false)
        }
    }, [date])

    const [openMobileCalendar, setOpenMobileCalendar] = useState(false);

    return (
        <div className={`${i18n.language === "en" ? "font-urban" : (i18n.language === "si" ? "font-noto" : "font-mukta")} bg-bgImg md:bg-bglarge  bg-no-repeat bg-cover min-h-screen w-screen flex flex-col justify-center pl-[20px] pr-[20px] md:items-center pt-[50px]`}>
            <div className="fixed inset-0 bg-white/50 z-0"></div>
            <Menu as="div" className="absolute top-0 right-0 m-[10px] text-left items-right z-20">
                <div>
                    <MenuButton className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-black hover:bg-gray-50">
                        {language === "Sinhala" ? "සිංහල" : (language === "Tamil" ? "தமிழ்" : language)}
                        <ChevronDownIcon aria-hidden="true" className="-mr-1 size-5 text-gray-400" />
                    </MenuButton>
                </div>

                <MenuItems
                    transition
                    className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                >
                    <div className="py-1">
                        <MenuItem>
                            <button
                                className="text-left w-full block px-4 py-2 text-sm text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                onClick={() => {
                                    setLanguage("English");
                                    changeLanguage('en')
                                }}
                            >
                                English
                            </button>
                        </MenuItem>
                        <MenuItem>
                            <button
                                className="text-left w-full block px-4 py-2 text-sm text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                onClick={() => {
                                    setLanguage("Sinhala");
                                    changeLanguage('si')
                                }}
                            >
                                සිංහල
                            </button>
                        </MenuItem>
                        <MenuItem>
                            <button
                                className="text-left w-full block px-4 py-2 text-sm text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                onClick={() => {
                                    setLanguage("Tamil");
                                    changeLanguage('ta')
                                }}
                            >
                                தமிழ்
                            </button>
                        </MenuItem>
                    </div>
                </MenuItems>
            </Menu>
            <div className='relative  z-10'>
                <div className='flex flex-col justify-center h-full sm:w-full md:w-[400px] lg:w-[500px] xl:w-[950px]'>
                    <img src="/images/logo.svg" className="h-[100px] md:h-[130px] xl:h-[120px] 2xl:h-[130px]" alt='logo' />
                    <p className={`text-[#1E2533] text-center font-[600] leading-[27px] xl:leading-[30px] ${i18n.language === "en" ? "text-[21px] md:text-[23px] lg:text-[27px] xl:text-[27px] 2xl:text-[28px]" : (i18n.language === "si" ? "text-[17px] md:text-[22px] lg:text-[19px] xl:text-[22px] 2xl:text-[18px]" : "text-[16px] md:text-[19px] lg:text-[17px] xl:text-[20px] 2xl:text-[18px]")} mt-[20px]`}>{t('t358')}</p>
                    <p className={`text-[#1E2533] text-left font-[500] leading-[27px] xl:leading-[30px] ${i18n.language === "en" ? "text-[16px] md:text-[18px] lg:text-[21px] xl:text-[17px] 2xl:text-[20px]" : (i18n.language === "si" ? "text-[12px] md:text-[16px] lg:text-[13px] xl:text-[16px] 2xl:text-[12px]" : "text-[12px] md:text-[13px] lg:text-[13px] xl:text-[14px] 2xl:text-[13px]")} mt-[20px]`}>{t('t452')}</p>

                    <div className='flex flex-col xl:grid xl:grid-cols-2 xl:items-center xl:justify-center xl:gap-[20px] xl:w-full xl:items-stretch'>
                        <div className='h-full xl:w-full'>
                            <div className="items-center mt-[10px] flex rounded-md bg-[#F1F6FB] px-[10px] h-[60px] md:h-[70px] xl:h-[55px] 2xl:h-[65px] outline outline-1 -outline-offset-1 outline-gray-400 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400">
                                <MdPerson size="24px" color="#8189B0" />
                                <input value={studentSignupDetails.name} type="text" name="name" className={`ml-[10px] w-full bg-[#F1F6FB] text-[15px] md:text-[17px] 2xl:text-[16px] text-gray-900 placeholder:text-gray-500 ${i18n.language === "en" ? "placeholder:text-[15px] md:placeholder:text-[17px] lg:placeholder:text-[19px] xl:placeholder:text-[15px] 2xl:placeholder:text-[17px]" : (i18n.language === "si" ? "placeholder:text-[14px] md:placeholder:text-[16px] lg:placeholder:text-[16px] xl:placeholder:text-[13px] 2xl:placeholder:text-[15px]" : "placeholder:text-[14px] md:placeholder:text-[15px] lg:placeholder:text-[16px] xl:placeholder:text-[13px] 2xl:placeholder:text-[15px]")} focus:outline focus:outline-0`} placeholder={t('t27')}
                                    onChange={(e) => {
                                        setstudentSignupDetails((prevState) => ({
                                            ...prevState, name: e.target.value
                                        }))
                                    }}
                                />
                            </div>
                            {errors.noName &&
                                <p className={`text-[#ff0000] ${i18n.language === "en" ? "text-[12px] xl:text-[13px] 2xl:text-[13px]" : (i18n.language === "si" ? "text-[12px] xl:text-[11px] 2xl:text-[12px]" : "text-[12px] xl:text-[11px] 2xl:text-[11px]")} mt-[5px]`}>{t('t29')}</p>
                            }
                            {errors.invalidName &&
                                <p className={`text-[#ff0000] ${i18n.language === "en" ? "text-[12px] xl:text-[13px] 2xl:text-[13px]" : (i18n.language === "si" ? "text-[12px] xl:text-[11px] 2xl:text-[12px]" : "text-[12px] xl:text-[11px] 2xl:text-[11px]")} mt-[5px]`}>{t('t28')}</p>
                            }
                        </div>

                        <div className='h-full xl:w-full'>
                            <div className="items-center mt-[20px] xl:mt-[10px] flex rounded-md bg-[#F1F6FB] px-[10px] h-[60px] md:h-[70px] xl:h-[55px] 2xl:h-[65px] outline outline-1 -outline-offset-1 outline-gray-400 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400">
                                <MdEmail size="24px" color="#8189B0" />
                                <input type="text" value={studentSignupDetails.email} name="email" disabled className={`ml-[10px] w-full bg-[#F1F6FB] text-[15px] md:text-[17px] 2xl:text-[16px] text-gray-900 placeholder:text-gray-500 ${i18n.language === "en" ? "placeholder:text-[15px] md:placeholder:text-[17px] lg:placeholder:text-[19px] xl:placeholder:text-[15px] 2xl:placeholder:text-[17px]" : (i18n.language === "si" ? "placeholder:text-[14px] md:placeholder:text-[16px] lg:placeholder:text-[16px] xl:placeholder:text-[13px] 2xl:placeholder:text-[15px]" : "placeholder:text-[14px] md:placeholder:text-[15px] lg:placeholder:text-[16px] xl:placeholder:text-[13px] 2xl:placeholder:text-[15px]")} focus:outline focus:outline-0`} placeholder={t('t14')}
                                    onChange={(e) => {
                                        setstudentSignupDetails((prevState) => ({
                                            ...prevState, email: e.target.value
                                        }))
                                    }}
                                />
                            </div>
                            {errors.noEmail &&
                                <p className={`text-[#ff0000] ${i18n.language === "en" ? "text-[12px] xl:text-[13px] 2xl:text-[13px]" : (i18n.language === "si" ? "text-[12px] xl:text-[11px] 2xl:text-[12px]" : "text-[12px] xl:text-[11px] 2xl:text-[11px]")} mt-[5px]`}>{t('t15')}</p>
                            }
                            {errors.invalidEmail &&
                                <p className={`text-[#ff0000] ${i18n.language === "en" ? "text-[12px] xl:text-[13px] 2xl:text-[13px]" : (i18n.language === "si" ? "text-[12px] xl:text-[11px] 2xl:text-[12px]" : "text-[12px] xl:text-[11px] 2xl:text-[11px]")} mt-[5px]`}>{t('t16')}</p>
                            }
                        </div>
                    </div>

                    <div className='flex flex-col xl:grid xl:grid-cols-4 xl:items-center xl:justify-center xl:gap-[10px] xl:w-full xl:items-stretch'>

                        <div className='h-full xl:w-full'>
                            <div className="items-center mt-[20px] flex h-[60px] md:h-[70px] xl:h-[50px] 2xl:h-[60px]">
                                <Menu as="div" className="w-full relative inline-block text-left py-[20px]">
                                    <div>
                                        <MenuButton
                                            disabled={disabled}
                                            className={`truncate pl-[20px] inline-flex w-full justify-left items-center rounded-md bg-[#F1F6FB] h-[60px] md:h-[70px] xl:h-[50px] 2xl:h-[60px] md:text-[16px] text-[15px] ${studentSignupDetails.district === "" ? (i18n.language === "en" ? "text-gray-500 text-[15px] md:text-[17px] lg:text-[20px] xl:text-[15px] 2xl:text-[17px]" : (i18n.language === "si" ? "text-gray-500 text-[10px] md:text-[17px] lg:text-[16px] xl:text-[13px] 2xl:text-[15px]" : "text-gray-500 text-[12px] md:text-[15px] lg:text-[16px] xl:text-[13px] 2xl:text-[15px]")) : 'text-gray-900'} shadow-sm ring-1 ring-inset ring-gray-400 hover:bg-gray-100 pr-[30px]`}
                                        >
                                            {studentSignupDetails.district === "" ? t('t55') : studentSignupDetails.district}
                                            <MdArrowDropDown
                                                aria-hidden="true"
                                                className="absolute right-[10px] size-8 text-gray-700"
                                            />
                                        </MenuButton>
                                    </div>

                                    <MenuItems
                                        transition
                                        className="absolute right-0 z-10 mt-2 w-full origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                                        style={{
                                            width: '100%',
                                            maxHeight: '200px', // Set a reasonable max height
                                            overflowY: 'auto' // Enable scrolling for overflow content
                                        }}
                                    >
                                        <div className="py-1">
                                            {
                                                districtArray.map((districtSelect, index) => (
                                                    <MenuItem key={index}>
                                                        <button
                                                            className="truncate text-left w-full block px-4 py-2 text-sm text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                                            onClick={() => {
                                                                setstudentSignupDetails((prev) => ({ ...prev, district: districtSelect }))
                                                            }}
                                                        >
                                                            {districtSelect}
                                                        </button>
                                                    </MenuItem>
                                                ))
                                            }
                                        </div>
                                    </MenuItems>
                                </Menu>
                            </div>

                            {errors.noDistrict &&
                                <p className={`text-[#ff0000] ${i18n.language === "en" ? "text-[12px] xl:text-[13px] 2xl:text-[13px]" : (i18n.language === "si" ? "text-[12px] xl:text-[11px] 2xl:text-[12px]" : "text-[12px] xl:text-[11px] 2xl:text-[11px]")} mt-[5px]`}>{t('t56')}</p>
                            }
                        </div>

                        <div className='h-full xl:w-full'>
                            <div className="items-center mt-[20px] flex h-[60px] md:h-[70px] xl:h-[50px] 2xl:h-[60px]">
                                <Menu as="div" className="w-full relative inline-block text-left py-[20px]">
                                    <div>
                                        <MenuButton
                                            className={`truncate pl-[20px] inline-flex w-full justify-left items-center rounded-md bg-[#F1F6FB] h-[60px] md:h-[70px] xl:h-[50px] 2xl:h-[60px] text-[15px] md:text-[16px] ${studentSignupDetails.ethnicity === "" ? (i18n.language === "en" ? "text-gray-500 text-[15px] md:text-[17px] lg:text-[20px] xl:text-[15px] 2xl:text-[17px]" : (i18n.language === "si" ? "text-gray-500 text-[10px] md:text-[16px] lg:text-[16px] xl:text-[13px] 2xl:text-[15px]" : "text-gray-500 text-[10px] md:text-[15px] lg:text-[16px] xl:text-[13px] 2xl:text-[15px]")) : 'text-[#1F2937]'} shadow-sm ring-1 ring-inset ring-gray-400 hover:bg-gray-100 pr-[30px]`}
                                        >
                                            {studentSignupDetails.ethnicity === "" ? t('t361') : studentSignupDetails.ethnicity}
                                            <MdArrowDropDown
                                                aria-hidden="true"
                                                className="absolute right-[10px] size-8 text-gray-700"
                                            />
                                        </MenuButton>
                                    </div>

                                    <MenuItems
                                        transition
                                        className="absolute right-0 z-10 mt-2 w-full origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                                        style={{
                                            width: '100%',
                                            maxHeight: '80px',
                                            overflowY: 'auto'
                                        }}
                                    >
                                        <div className="py-1">
                                            {
                                                ethnicityArray.map((genderSelect, index) => (
                                                    <MenuItem key={index}>
                                                        <button
                                                            className="truncate text-left w-full block px-4 py-2 text-sm text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                                            onClick={() => {
                                                                setstudentSignupDetails((prev) => ({ ...prev, ethnicity: genderSelect }))
                                                            }}
                                                        >
                                                            {genderSelect}
                                                        </button>
                                                    </MenuItem>
                                                ))
                                            }
                                        </div>
                                    </MenuItems>
                                </Menu>
                            </div>

                            {errors.noEthnicity &&
                                <p className={`text-[#ff0000] ${i18n.language === "en" ? "text-[12px] xl:text-[13px] 2xl:text-[13px]" : (i18n.language === "si" ? "text-[12px] xl:text-[11px] 2xl:text-[12px]" : "text-[12px] xl:text-[11px] 2xl:text-[11px]")} mt-[5px]`}>{t('t362')}</p>
                            }
                        </div>

                        <div className='h-full xl:w-full'>
                            <div className="items-center mt-[20px] flex h-[60px] md:h-[70px] xl:h-[50px] 2xl:h-[60px]">
                                <Menu as="div" className="w-full relative inline-block text-left py-[20px]">
                                    <div>
                                        <MenuButton
                                            className={`truncate pl-[20px] inline-flex w-full justify-left items-center rounded-md bg-[#F1F6FB] h-[60px] md:h-[70px] xl:h-[50px] 2xl:h-[60px] text-[15px] md:text-[16px] ${studentSignupDetails.gender === "" ? (i18n.language === "en" ? "text-gray-500 text-[15px] md:text-[17px] lg:text-[20px] xl:text-[15px] 2xl:text-[17px]" : (i18n.language === "si" ? "text-gray-500 text-[10px] md:text-[16px] lg:text-[16px] xl:text-[13px] 2xl:text-[15px]" : "text-gray-500 text-[10px] md:text-[15px] lg:text-[16px] xl:text-[13px] 2xl:text-[15px]")) : 'text-[#1F2937]'} shadow-sm ring-1 ring-inset ring-gray-400 hover:bg-gray-100 pr-[30px]`}
                                        >
                                            {studentSignupDetails.gender === "" ? t('t43') : studentSignupDetails.gender}
                                            <MdArrowDropDown
                                                aria-hidden="true"
                                                className="absolute right-[10px] size-8 text-gray-700"
                                            />
                                        </MenuButton>
                                    </div>

                                    <MenuItems
                                        transition
                                        className="absolute right-0 z-10 mt-2 w-full origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                                        style={{
                                            width: '100%',
                                            maxHeight: '80px',
                                            overflowY: 'auto'
                                        }}
                                    >
                                        <div className="py-1">
                                            {
                                                genderArray.map((genderSelect, index) => (
                                                    <MenuItem key={index}>
                                                        <button
                                                            className="truncate text-left w-full block px-4 py-2 text-sm text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                                            onClick={() => {
                                                                setstudentSignupDetails((prev) => ({ ...prev, gender: genderSelect }))
                                                            }}
                                                        >
                                                            {genderSelect}
                                                        </button>
                                                    </MenuItem>
                                                ))
                                            }
                                        </div>
                                    </MenuItems>
                                </Menu>
                            </div>

                            {errors.noGender &&
                                <p className={`text-[#ff0000] ${i18n.language === "en" ? "text-[12px] xl:text-[13px] 2xl:text-[13px]" : (i18n.language === "si" ? "text-[12px] xl:text-[11px] 2xl:text-[12px]" : "text-[12px] xl:text-[11px] 2xl:text-[11px]")} mt-[5px]`}>{t('t40')}</p>
                            }
                        </div>

                        <div className='h-full xl:w-full'>
                            <div className="flex justify-center items-center mt-[20px]  bg-[#F1F6FB] h-[60px] md:h-[70px] xl:h-[50px] 2xl:h-[60px] rounded-lg shadow-sm ring-1 ring-inset ring-gray-400 pr-[10px] pl-[5px]">
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        value={date ? dayjs(date) : null}
                                        onChange={(date) => {
                                            if (date) {
                                                const formattedDate = dayjs(date).format('YYYY-MM-DD');
                                                setDate(formattedDate)
                                                setstudentSignupDetails((prevDetails) => ({
                                                    ...prevDetails,
                                                    dateOfBirth: formattedDate,
                                                }));
                                            }
                                        }}
                                        format="YYYY-MM-DD"
                                        open={openMobileCalendar} // this will open calendar programmatically
                                        onClose={() => setOpenMobileCalendar(false)}
                                        components={{
                                            OpenPickerIcon: () => null,
                                        }}
                                        slotProps={{
                                            textField: {
                                                InputProps: {
                                                    style: {
                                                        border: 'none',
                                                        fontSize: '15px',
                                                        color: '#000000',
                                                        fontFamily: 'Urbanist',
                                                    },
                                                    endAdornment: null
                                                },
                                                placeholder: t('t41'),
                                                fullWidth: true,
                                                sx: {
                                                    '& .MuiOutlinedInput-root': {
                                                        border: 'none', // Remove outer border
                                                        boxShadow: 'none', // Remove shadow
                                                    },
                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                        border: 'none', // Remove outlined border
                                                    },
                                                    '&:hover .MuiOutlinedInput-notchedOutline': {
                                                        border: 'none', // Remove hover effect
                                                    },
                                                    '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                        border: 'none', // Remove focus effect
                                                    },
                                                    '& input::placeholder': {
                                                        color: '#6B7280',
                                                        opacity: 1, // for consistent appearance in Firefox
                                                        fontSize: {
                                                            xs: i18n.language === 'en' ? '15px' : i18n.language === "si" ? '19px' : '17px',
                                                            sm: i18n.language === 'en' ? '16px' : i18n.language === "si" ? '21px' : '18px',
                                                            md: i18n.language === 'en' ? '19px' : i18n.language === "si" ? '21px' : '19px',
                                                            lg: i18n.language === 'en' ? '16px' : i18n.language === "si" ? '17px' : '15px',
                                                            xl: i18n.language === 'en' ? '16px' : i18n.language === "si" ? '18px' : '18px'
                                                        },
                                                    },
                                                },
                                            },
                                        }}
                                    />
                                </LocalizationProvider>
                                <MdCalendarMonth
                                    size="30px"
                                    className="text-gray-500 ml-[10px] hover:cursor-pointer rounded-full focus:outline-none hover:ring-2 hover:ring-offset-2 hover:ring-gray-300 active:ring-2 active:ring-gray-400 active:ring-offset-2 transition duration-150 ease-in-out"
                                    onClick={() => setOpenMobileCalendar(true)}
                                    tabIndex={0}
                                    role="button"
                                />
                            </div>
                            {errors.noDOB &&
                                <p className={`text-[#ff0000] ${i18n.language === "en" ? "text-[12px] xl:text-[13px] 2xl:text-[13px]" : (i18n.language === "si" ? "text-[12px] xl:text-[11px] 2xl:text-[12px]" : "text-[12px] xl:text-[11px] 2xl:text-[11px]")} mt-[5px]`}>{t('t42')}</p>
                            }
                        </div>
                    </div>

                    <p className={`text-[#1E2533] text-left font-[500] leading-[27px] xl:leading-[30px] ${i18n.language === "en" ? "text-[16px] md:text-[18px] lg:text-[21px] xl:text-[17px] 2xl:text-[20px]" : (i18n.language === "si" ? "text-[12px] md:text-[16px] lg:text-[13px] xl:text-[16px] 2xl:text-[12px]" : "text-[12px] md:text-[13px] lg:text-[13px] xl:text-[14px] 2xl:text-[13px]")} mt-[10px]`}>{t('t453')}</p>
                    <div className='flex flex-col xl:grid xl:grid-cols-2 xl:items-center xl:justify-center xl:gap-[20px] xl:w-full xl:items-stretch'>
                        <div className='h-full xl:w-full'>
                            <div className="items-center mt-[10px] flex rounded-md bg-[#F1F6FB] pl-[10px] pr-[20px] h-[60px] md:h-[70px] xl:h-[60px] 2xl:h-[70px] outline outline-1 -outline-offset-1 outline-gray-400 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400">
                                <MdLock size="26px" color="#8189B0" />
                                <input type={isVisibleText ? "text" : "password"}
                                    name="password"
                                    value={studentSignupDetails.password}
                                    className={`ml-[10px] mr-[10px] w-full bg-[#F1F6FB] text-gray-900  ${isVisibleText ? 'text-[15px] tracking-wide' : 'text-[25px] tracking-widest'} placeholder:text-[#6B7280] ${i18n.language === "en" ? "placeholder:text-[15px] md:placeholder:text-[17px] lg:placeholder:text-[20px] xl:placeholder:text-[15px] 2xl:placeholder:text-[17px]" : (i18n.language === "si" ? "placeholder:text-[14px] md:placeholder:text-[16px] lg:placeholder:text-[16px] xl:placeholder:text-[13px] 2xl:placeholder:text-[15px]" : "placeholder:text-[14px] md:placeholder:text-[15px] lg:placeholder:text-[16px] xl:placeholder:text-[13px] 2xl:placeholder:text-[15px]")} focus:outline focus:outline-0`} style={{}} placeholder={t('t17')}
                                    onChange={(e) => {

                                        const inputValue = e.target.value.replace(/\s+/g, '').trim();
                                        if (inputValue !== "") {
                                            setErrors((prev) => ({ ...prev, noPassword: false }));
                                            if (regexPatterns[2].test(inputValue)) {
                                                setPasswordStatus((prev) => ({ ...prev, medium: false, weak: false, strong: true }));

                                            } else if (regexPatterns[1].test(inputValue)) {
                                                setPasswordStatus((prev) => ({ ...prev, medium: true, weak: false, strong: false }));

                                            } else if (regexPatterns[0].test(inputValue)) {
                                                setPasswordStatus((prev) => ({ ...prev, medium: false, weak: true, strong: false }));

                                            } else {
                                                setPasswordStatus((prev) => ({ ...prev, medium: true, weak: false, strong: false }));

                                            }
                                        } else {
                                            setErrors((prev) => ({ ...prev, noPassword: false }));
                                            setPasswordStatus((prev) => ({ ...prev, medium: false, weak: false, strong: false }));
                                        }

                                        if (inputValue !== '') {
                                            if (!regexPatterns[3].test(inputValue)) {
                                                setErrorMessageNumber(1)
                                            } else if (!regexPatterns[4].test(inputValue)) {
                                                setErrorMessageNumber(2)
                                            } else if (!regexPatterns[5].test(inputValue)) {
                                                setErrorMessageNumber(3)
                                            } else if (!regexPatterns[6].test(inputValue)) {
                                                setErrorMessageNumber(4)
                                            } else if (!regexPatterns[7].test(inputValue)) {
                                                setErrorMessageNumber(5)
                                            } else {
                                                setErrorMessageNumber(0)
                                            }
                                        } else {
                                            setErrorMessageNumber(0)
                                        }

                                        setstudentSignupDetails((prevState) => ({
                                            ...prevState, password: inputValue
                                        }));
                                        if (!isVisible && inputValue.length > 0) {
                                            setIsVisibleText(false);
                                        } else {
                                            setIsVisibleText(true);
                                        }
                                    }}
                                />
                                {
                                    isVisible ? <MdVisibilityOff onClick={handleVisiblityClick} size="24px" color="#8189B0" /> : <MdVisibility onClick={handleVisiblityClick} size="24px" color="#8189B0" />
                                }
                            </div>

                            {errors.noPassword &&
                                <p className={`text-[#ff0000] ${i18n.language === "en" ? "text-[12px] xl:text-[13px] 2xl:text-[13px]" : (i18n.language === "si" ? "text-[12px] xl:text-[11px] 2xl:text-[12px]" : "text-[12px] xl:text-[11px] 2xl:text-[11px]")} mt-[5px]`}>{t('t18')}</p>
                            }

                            {passwordStatus.weak && <p className={`text-black ${i18n.language === "en" ? "text-[12px] xl:text-[13px] 2xl:text-[13px]" : (i18n.language === "si" ? "text-[12px] xl:text-[11px] 2xl:text-[12px]" : "text-[12px] xl:text-[11px] 2xl:text-[11px]")} mt-[5px] `}>{t('t65')}<span className='text-[#fc0000] font-bold'>{t('t66')}</span></p>
                            }
                            {passwordStatus.medium && <p className={`text-black ${i18n.language === "en" ? "text-[12px] xl:text-[13px] 2xl:text-[13px]" : (i18n.language === "si" ? "text-[12px] xl:text-[11px] 2xl:text-[12px]" : "text-[12px] xl:text-[11px] 2xl:text-[11px]")} mt-[5px]`}>{t('t65')}<span className='text-[#fc8600] font-bold'>{t('t67')}</span></p>
                            }
                            {passwordStatus.strong && <p className={`text-black ${i18n.language === "en" ? "text-[12px] xl:text-[13px] 2xl:text-[13px]" : (i18n.language === "si" ? "text-[12px] xl:text-[11px] 2xl:text-[12px]" : "text-[12px] xl:text-[11px] 2xl:text-[11px]")} mt-[5px]`}>{t('t65')}<span className='text-[#099509] font-bold'>{t('t68')}</span></p>
                            }

                            {errorMessageNumber !== 0 && <p className={`text-[#ff0000] ${i18n.language === "en" ? "text-[12px] xl:text-[13px] 2xl:text-[13px]" : (i18n.language === "si" ? "text-[12px] xl:text-[11px] 2xl:text-[12px]" : "text-[12px] xl:text-[11px] 2xl:text-[11px]")} mt-[5px]`} >{errorMessages[errorMessageNumber]}</p>}


                        </div>

                        <div className='h-full xl:w-full'>
                            <div className="items-center mt-[10px] flex rounded-md bg-[#F1F6FB] pl-[10px] pr-[20px] h-[60px] md:h-[70px] xl:h-[60px] 2xl:h-[70px] outline outline-1 -outline-offset-1 outline-gray-400 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400">
                                <MdLock size="26px" color="#8189B0" />
                                <input type={isVisibleText2 ? "text" : "password"} name="password_confirm"
                                    value={studentSignupDetails.confirmPassword}
                                    className={`ml-[10px] mr-[10px] w-full bg-[#F1F6FB] text-gray-900 ${isVisibleText2 ? 'text-[15px] tracking-wide' : 'text-[25px] tracking-widest'} placeholder:text-gray-500 ${i18n.language === "en" ? "placeholder:text-[15px] md:placeholder:text-[17px] lg:placeholder:text-[20px] xl:placeholder:text-[15px] 2xl:placeholder:text-[17px]" : (i18n.language === "si" ? "placeholder:text-[14px] md:placeholder:text-[16px] lg:placeholder:text-[16px] xl:placeholder:text-[13px] 2xl:placeholder:text-[15px]" : "placeholder:text-[14px] md:placeholder:text-[15px] lg:placeholder:text-[16px] xl:placeholder:text-[13px] 2xl:placeholder:text-[15px]")} focus:outline focus:outline-0`} placeholder={t('t30')}
                                    onChange={(e) => {
                                        const inputValue = e.target.value.replace(/\s+/g, '').trim();
                                        setstudentSignupDetails((prevState) => ({
                                            ...prevState, confirmPassword: inputValue
                                        }));
                                        if (!isVisible2 && inputValue.length > 0) {
                                            setIsVisibleText2(false);
                                        } else {
                                            setIsVisibleText2(true);
                                        }
                                    }}
                                />
                                {
                                    isVisible2 ? <MdVisibilityOff onClick={handleVisiblityClick2} size="24px" color="#8189B0" /> : <MdVisibility onClick={handleVisiblityClick2} size="24px" color="#8189B0" />
                                }
                            </div>
                            {errors.passwordsNotMatch &&
                                <p className={`text-[#ff0000]  ${i18n.language === "en" ? "text-[12px] xl:text-[13px] 2xl:text-[13px]" : (i18n.language === "si" ? "text-[12px] xl:text-[11px] 2xl:text-[12px]" : "text-[12px] xl:text-[11px] 2xl:text-[11px]")} mt-[5px]`}>{t('t26')}</p>
                            }
                        </div>
                    </div>

                    <div className='w-full flex gap-[10px] items-center justify-center xl:justify-end pb-[30px]'>
                        <button onClick={() => { navigate('/registerasstudent'); }} className={`${i18n.language === "en" ? "text-[18px] md:text-[18px] xl:text-[17px] 2xl:text-[22px]" : (i18n.language === "si" ? "text-[16px] md:text-[14px] xl:text-[14px] 2xl:text-[19px]" : "text-[16px] md:text-[14px] xl:text-[13px] 2xl:text-[18px]")} mt-[20px] rounded-lg pt-[10px] pb-[10px] w-full xl:w-[150px] hover:bg-opacity-80 text-[#EFAE03] bg-transparent border border-[#EFAE03] border-[2px] font-bold`}>{t('t455')}</button>
                        <button onClick={handleContinue} className={`${i18n.language === "en" ? "text-[18px] md:text-[18px] xl:text-[17px] 2xl:text-[22px]" : (i18n.language === "si" ? "text-[16px] md:text-[14px] xl:text-[14px] 2xl:text-[19px]" : "text-[16px] md:text-[14px] xl:text-[13px] 2xl:text-[18px]")} mt-[20px] rounded-lg pt-[10px] pb-[10px] w-full xl:w-[200px] hover:bg-opacity-80 text-white bg-[#EFAE03] font-bold`}>{t('t7')}</button>
                    </div>

                    <Dialog
                        open={open}
                        onClose={handleClose}
                        aria-labelledby="custom-dialog-title"
                        aria-describedby="custom-dialog-description"
                        className="backdrop-blur-sm"
                    >
                        <DialogTitle
                            id="custom-dialog-title"
                            className="text-2xl font-bold text-gray-800 border-b border-gray-300 pb-2"
                        >
                            ⚠️  {t('t48')}
                        </DialogTitle>
                        <DialogContent className="bg-gray-50">
                            <DialogContentText
                                id="custom-dialog-description"
                                className="text-gray-600 text-md mt-2"
                            >
                                {t('t10')}
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions className="px-4 py-2">
                            <Button
                                onClick={handleClose}
                                className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                                style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                            >
                                {t('t13')}
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            </div>
        </div>
    );
}

export default StudentSignUp1;